import { useSetAtom } from 'jotai'
import React, { useState } from 'react'
import { TransactionResult } from 'src/common/contracts/hooks/useExecuteTx'
import Modal, { ModalProps } from 'src/common/ui-kit/Modal'
import { viccCountAtom } from '../bundle-store'
import CarbonBundleSuccess from '../components/CarbonBundleSuccess'
import CarbonBundleDeposit from './CarbonBundleDeposit'

interface CarbonBundleDepositModalProps extends ModalProps {}

enum View {
  Deposit,
  Success,
}

const CarbonBundleDepositModal: React.FC<
  CarbonBundleDepositModalProps
> = props => {
  const [tx, setTx] = useState<TransactionResult>()
  const [view, setView] = useState<View>(View.Deposit)

  const setViccCount = useSetAtom(viccCountAtom)

  const isDepositView = view === View.Deposit
  const isSuccessView = view === View.Success

  const handleSuccess = (tx: TransactionResult) => {
    setTx(tx)
    setView(View.Success)
  }

  const resetStore = () => {
    setViccCount(0)
  }

  const handleClose = () => {
    setView(View.Deposit)
    props.onClose?.()
    resetStore()
  }

  return (
    <Modal {...props} onClose={handleClose}>
      {isDepositView && <CarbonBundleDeposit onSuccess={handleSuccess} />}
      {isSuccessView && tx && (
        <CarbonBundleSuccess tx={tx} onClose={handleClose} mode='deposit' />
      )}
    </Modal>
  )
}

export default CarbonBundleDepositModal
